import { StyleSheet } from 'react-native';

export default StyleSheet.create({
	row: {
		flex: 1,
		flexDirection: 'row',
		alignItems: 'center', //along col
		justifyContent: 'space-around', //along row:flex-start, center, flex-end, space-around, space-between and space-evenly.
		paddingHorizontal: 20,
		paddingVertical: 2
	},
	pad: {
		flex: 1,
		margin: 5
	},
	btn: {
		borderWidth: 1,
		flex: 1,
		margin: 5,
		borderColor: 'rgba(0,0,0,0.2)',
		alignItems: 'center',
		justifyContent: 'center',
		backgroundColor: '#fff',
		borderRadius: 100,
		minHeight: 30
	},
	btntxt: {
		fontFamily: 'Roboto',
		fontSize: 40,
		//lineHeight: 50,
		color: '#438eb9',
		textAlign: 'center',
		alignItems: 'center',
		margin: 4,
		marginLeft: 20,
		marginRight: 20,
		minHeight: 30
	},
	header: {
		fontSize: 20,
		fontWeight: '400',
		textAlign: 'center'
	},
	pin: {
		fontFamily: 'Roboto',
		fontSize: 30,
		textAlign: 'center',
		alignSelf: 'center',
		fontWeight: '500',
		width: '100%',
		includeFontPadding: true
	}
});
